import { useState, useCallback } from 'react';
import { CERTIFICADO_ENDPOINT } from '../../../hooks/constants';
import { avaliableActions } from '../../../models/actions';

export const useCertificadosActions = ({
  backendPost,
  backendPut,
  backendDelete,
  showNotification,
  fetchData,
}) => {
  const [sendLoading, setSendLoading] = useState(false);
  const [idCertificado, setIdCertificado] = useState(0);

  const handleUpdate = useCallback(
    (id) => async (params) => {
      try {
        await backendPut(`${CERTIFICADO_ENDPOINT}/${id}`, params);
        fetchData({ sort: { field: 'dataConclusao', type: 'DESC' } });
        return { success: true };
      } catch (e) {
        console.error(e);
        return { ...e };
      }
    },
    [backendPut, fetchData],
  );

  const handleSendCertificado = useCallback(
    // eslint-disable-next-line
    (id, tipo) => {
      if (!id) return;

      const isEmail = tipo === 'email';
      setSendLoading(true);
      setIdCertificado(id);

      backendPost(`${CERTIFICADO_ENDPOINT}/${id}/${tipo}`)
        .then(() =>
          showNotification({
            message: `Reenvio de ${
              isEmail ? 'e-mail ao cliente' : tipo
            } solicitado com sucesso!`,
            color: 'confirmation',
          }),
        )
        .catch((error) =>
          showNotification({
            message: `Não foi possível realizar o envio do certificado por ${
              isEmail ? 'e-mail' : tipo
            }`,
            supportMessage: error?.message ?? '',
            color: 'destructive',
          }),
        )
        .finally(() => setSendLoading(false));
    },
    [backendPost, showNotification],
  );

  const handleDeleteAction = useCallback(
    async (action, id) => {
      if (action !== avaliableActions.confirmar) return true;

      try {
        await backendDelete(`${CERTIFICADO_ENDPOINT}/${id}`);
        showNotification({
          message: 'Registro excluído com sucesso!',
          color: 'confirmation',
        });
        fetchData({ sort: { field: 'dataConclusao', type: 'DESC' } });
        return { success: true };
      } catch (e) {
        console.error(e);
        return { ...e };
      }
    },
    [backendDelete, fetchData, showNotification],
  );

  const handleReativarAction = useCallback(
    async (action, id) => {
      if (action !== avaliableActions.confirmarReativar) return true;

      try {
        await backendPut(`${CERTIFICADO_ENDPOINT}/${id}/ativar`);
        showNotification({
          message: 'Certificado reativado com sucesso!',
          color: 'confirmation',
        });
        fetchData({ sort: { field: 'dataConclusao', type: 'DESC' } });
        return { success: true };
      } catch (e) {
        console.error(e);
        showNotification({
          message: 'Não foi possível reativar o certificado.',
          supportMessage: e?.message ?? '',
          color: 'destructive',
        });
        return { ...e };
      }
    },
    [backendPut, fetchData, showNotification],
  );

  return {
    sendLoading,
    setSendLoading,
    idCertificado,
    handleUpdate,
    handleSendCertificado,
    handleDeleteAction,
    handleReativarAction,
  };
};
